module.exports = __webpack_public_path__ + "assets/icon_employee_survey.f7336ebd.svg";